import { ADD_SETTINGS } from "../../Constants/reduxKeys";

let initialState = {
	settings: null,
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_SETTINGS:
			return {
				...state,
				settings: state.settings
					? {
							...state.settings,
							...action.payload,
					  }
					: action.payload,
			};
		default:
			break;
	}
	return state;
};

export default reducer;
